import {useMemo} from 'react';
import type {Brand} from '@Components/mystuff-brands/brand-kits.types';
import {BrandKitSource} from '@Components/mystuff-brands/brand-kits.types';
import {useBrandKitsFromStore} from '@Hooks/brands/useBrandKitsFromStore';
import {useActiveBrandId} from '@Hooks/brands/useActiveBrandId';

/** The active kit first, then the Halloween kit, then the rest in store order. Stable while the kits and the active id are. */
export const useSortedBrandKitsFromStore = (): Brand[] => {
  const brands = useBrandKitsFromStore();
  const activeBrandId = useActiveBrandId();

  return useMemo(() => {
    const activeBrandKit: Brand[] = [];
    const halloweenBrandKit: Brand[] = [];
    const otherBrandKits: Brand[] = [];

    brands.forEach((brand) => {
      if (brand.brandId === activeBrandId) {
        activeBrandKit.push(brand);
      } else if (brand.source === BrandKitSource.HALLOWEEN_PROMOTION) {
        halloweenBrandKit.push(brand);
      } else {
        otherBrandKits.push(brand);
      }
    });

    return [...activeBrandKit, ...halloweenBrandKit, ...otherBrandKits];
  }, [brands, activeBrandId]);
};
